export default "__VITE_ASSET__Bdg3XdDs__"